<template>
  <div :class="notificationClass">
    <div class="notification__message-wrapper">
      <span class="notification__icon">
        <ui-icon type="round">{{ notificationIcon }}</ui-icon>
      </span>
      <p class="notification__message">
        <slot name="notification-message">
          <div v-html="getActiveNotification?.value?.notificationMessageTemplate" />
        </slot>
      </p>
      <!-- notification__message -->
    </div>
    <!-- notification__message-wrapper -->
    <div
      class="notification__button-group"
      v-if="hasButtonGroup"
    >
      <acv-button
        variant="notification"
        @click="dismiss"
      >
        Dismiss
      </acv-button>
      <slot name="additional-buttons">
        <AcvButton
          v-for="(item, index) in getActiveNotification?.value?.additionalButtons"
          :key="index"
          @click="item.callback"
          variant="link"
          :data-test-id="item?.data"
        >
          {{ item.label }}
        </AcvButton>
      </slot>
    </div>
  </div>
  <!-- notification -->
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useNotificationsStore } from '@/stores/useNotifications';
import useBannerStyle from '@/composables/useBannerStyle';

const props = defineProps({
  variant: {
    type: String,
    default: 'success',
  },
  hasButtonGroup: {
    type: Boolean,
    default: true,
  },
});

const BLOCK_CLASS = 'notification';
const notificationsStore = useNotificationsStore();
const { getActiveNotification } = storeToRefs(notificationsStore);
const { bannerBaseClass, bannerIcon } = useBannerStyle();

const notificationClass = computed(() => bannerBaseClass(BLOCK_CLASS, props.variant));
const notificationIcon = computed(() => bannerIcon(props.variant));

const emit = defineEmits(['dismissClicked']);

const dismiss = () => {
  emit('dismissClicked');
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/notifications';
</style>
